import script from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceLayout.vue?vue&type=style&index=0&id=186ebbc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-186ebbc6"]])

export default __exports__